import React from "react";
import { LunchPackagesForm } from "./LunchPackagesForm";
import { Button } from "../../Button";
import { useAddLunchPackages } from "../../../hooks/lunchPackages/lunchPackages.hooks";
import { useDispatch } from "react-redux";
import { setWarningMessage } from "../../../Redux/Slices/alert.slice";

export const AddLunchPackages = () => {
  const dispatch = useDispatch();

  const [packageName, setPackageName] = React.useState<string>("");
  const [packageRate, setPackageRate] = React.useState<string>("");

  const { isLoading: isAddingLunchPackage, mutate: addLunchPackages } =
    useAddLunchPackages({
      onSuccess: () => {},
      onError: (error: Error) => {},
    });

  const handleAddLunchPackage = () => {
    if (!packageName) {
      return dispatch(setWarningMessage("Please enter package name"));
    }

    if (!packageRate) {
      return dispatch(setWarningMessage("Please enter package rate"));
    }

    addLunchPackages({
      package_name: packageName,
      rate: +packageRate,
    });
  };

  return (
    <>
      <LunchPackagesForm
        packageName={packageName}
        setPackageName={setPackageName}
        packageRate={packageRate}
        setPackageRate={setPackageRate}
      />

      <Button
        text="Add package"
        loading={isAddingLunchPackage}
        onClick={handleAddLunchPackage}
      />
    </>
  );
};
